import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import clearPersistedStateMiddleware from "./middleware";
import rootReducer from "./rootReducer";

const persistConfig = {
	key: "root",
	storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) => {
		const defaultMiddlewares = getDefaultMiddleware({
			serializableCheck: false,
			immutableCheck: false,
		});
		return [...defaultMiddlewares, clearPersistedStateMiddleware];
	},
	devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

// Purge persisted state
// persistor.purge();
